export default __webpack_public_path__ + "static/media/GEHC-LOGO.595a251b.png";